import React from 'react';

const ListSearchBar = ({
  value,
  onChange,
  placeholder = 'Search records...',
  disabled = false,
  isSearching = false
}) => {
  const isSearchBusy = Boolean(isSearching);
  const isInputLocked = Boolean(disabled) && !isSearchBusy;
  const hasTrailingControls = isSearchBusy || Boolean(value);

  const handleInputChange = (e) => {
    if (isSearchBusy) {
      return;
    }
    onChange(e.target.value);
  };

  return (
    <div
      className="list-search-wrap"
      style={{
        position: 'relative',
        flex: '1 1 320px',
        minWidth: '220px',
        maxWidth: '360px'
      }}
    >
      <input
        type="text"
        className="list-search-input"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={isInputLocked}
        readOnly={isSearchBusy}
        style={{
          minWidth: 0,
          maxWidth: 'none',
          width: '100%',
          paddingRight: hasTrailingControls ? '5.5rem' : '0.75rem'
        }}
      />
      {isSearching && (
        <span
          className="spinner-border spinner-border-sm text-secondary"
          role="status"
          aria-label="Searching"
          title="Searching"
          style={{
            position: 'absolute',
            right: value ? '3.2rem' : '0.75rem',
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        />
      )}
      {value && (
        <button
          type="button"
          className="list-search-clear"
          onClick={() => onChange('')}
          disabled={isInputLocked || isSearchBusy}
          aria-label="Clear search"
          title="Clear search"
          style={{
            position: 'absolute',
            right: '0.4rem',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '28px',
            padding: '0 0.55rem'
          }}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default ListSearchBar;
